import MetadataMetadata from './MetadataMetadata';

export { type MetadataMetadataProps } from './MetadataMetadata';

export default MetadataMetadata;
